import mediator from '../utilities/mediator';
import log from '../utilities/log';
import { ApiErrorResponse, SystemAbout } from '../models';
import { queryOptions, UseQueryOptions } from '@tanstack/react-query';

export function systemAboutQueryOptions(
  options?: Partial<UseQueryOptions<SystemAbout>>,
) {
  return queryOptions<SystemAbout>({
    ...options,
    queryKey: ['system', 'about'],
    queryFn: async () => {
      try {
        return await mediator.request<SystemAbout>('system:getAbout');
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
  });
}
